
import React from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import VideoHeader from "@/components/blueprint/VideoHeader";

interface BlueprintHeroProps {
  isEnrolled: boolean;
  isCourseAvailable: boolean;
  introLessonId: string | null;
  formatReleaseDate: () => string;
  handleWatchIntroClick: () => void;
  onEnrollClick: () => void;
  handleScrollToPricing: () => void; 
}

const BlueprintHero: React.FC<BlueprintHeroProps> = ({
  isEnrolled,
  isCourseAvailable,
  introLessonId,
  formatReleaseDate,
  handleWatchIntroClick,
  handleScrollToPricing
}) => {
  return (
    <section className="text-center flex flex-col items-center gap-6 mb-16">
      <h1 className="text-4xl md:text-5xl font-bold leading-tight">
        BoardSight Blueprint
      </h1>
      <p className="max-w-2xl text-lg md:text-xl text-gray-600">
        AI Oversight at Board Level is the <span className="font-medium">Forward-Looking Duty You Can't Delegate</span>
      </p>
      
      {/* Intro Video Section */}
      <VideoHeader 
        videoUrl="https://qcgnklqgyzwvjrmhzwfj.supabase.co/storage/v1/object/public/assets//BoardSight-Course-Intro.mp4" 
        className="w-full max-w-3xl my-8"
        autoPlay={true}
      />
      
      {/* Call to Action */}
      <div className="flex flex-col items-center gap-4">
        {isEnrolled && introLessonId ? (
          <Button 
            size="lg" 
            className="px-8 py-6 text-lg bg-techne-purple hover:bg-techne-deepPurple"
            onClick={handleWatchIntroClick}
          >
            {isCourseAvailable ? "Access Your Course" : "Watch Intro Video"}
          </Button>
        ) : (
          <Button 
            size="lg" 
            className="px-8 py-6 text-lg bg-techne-purple hover:bg-techne-deepPurple"
            onClick={handleScrollToPricing}
          >
            Reserve for December 1, 2025 Cohort
          </Button>
        )}
        
        {!isEnrolled && (
          <p className="text-sm text-muted-foreground">
            Join our December 1, 2025 cohort
          </p>
        )}
        
        {!isCourseAvailable && isEnrolled && (
          <div className="flex items-center gap-2 bg-amber-50 text-amber-800 px-4 py-2 rounded-md mt-4">
            <Calendar className="h-4 w-4" />
            <span>Full course content will be available December 1, 2025</span>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlueprintHero;
